import React from 'react';
import { ChevronRight, BoxIcon } from 'lucide-react';
import { DjayNarrator } from '../../../mascot';
export interface PriorityAlert {
  id: string;
  icon: BoxIcon;
  tone: 'urgent' | 'warning' | 'info' | 'success';
  message: string;
  onClick?: () => void;
}
interface PriorityAlertBarProps {
  alerts: PriorityAlert[];
  maxVisible?: number;
}
const TONE_ROW: Record<PriorityAlert['tone'], string> = {
  urgent: 'border-l-rose-500 bg-rose-50/30',
  warning: 'border-l-amber-500 bg-amber-50/30',
  info: 'border-l-indigo-500 bg-indigo-50/30',
  success: 'border-l-emerald-500 bg-emerald-50/30'
};
const TONE_ROW_HOVER: Record<PriorityAlert['tone'], string> = {
  urgent: 'hover:bg-rose-50/60',
  warning: 'hover:bg-amber-50/60',
  info: 'hover:bg-indigo-50/60',
  success: 'hover:bg-emerald-50/60'
};
const TONE_ICON: Record<PriorityAlert['tone'], string> = {
  urgent: 'text-rose-500',
  warning: 'text-amber-500',
  info: 'text-indigo-500',
  success: 'text-emerald-500'
};
export function PriorityAlertBar({
  alerts,
  maxVisible = 3
}: PriorityAlertBarProps) {
  if (alerts.length === 0) {
    return <div className="bg-emerald-50/40 border border-emerald-100 rounded-xl p-4 flex flex-col items-center justify-center text-center" data-id="element-9419" data-mp="39qkp9ytxcmkp">
        <DjayNarrator size="sm" emotion="happy" data-id="element-9420" data-mp="2w0r2dm1zccdm" />
        <p className="text-sm font-bold text-emerald-800 mt-2" data-id="element-9421" data-mp="30xhig9dsb7z1">
          Niks dringends vandaag 🌞
        </p>
      </div>;
  }
  const visibleAlerts = alerts.slice(0, maxVisible);
  const hiddenCount = alerts.length - maxVisible;
  return <div className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm divide-y divide-slate-100" role="list" aria-label="Belangrijke meldingen" data-id="element-9422" data-mp="3soncc82ww9fv">
      {visibleAlerts.map(alert => {
      const Icon = alert.icon;
      const baseRow = `w-full flex items-center gap-3 p-3 border-l-[3px] text-left transition-colors ${TONE_ROW[alert.tone]}`;
      if (alert.onClick) {
        return <button key={alert.id} type="button" onClick={alert.onClick} className={`${baseRow} ${TONE_ROW_HOVER[alert.tone]} cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-inset`} data-id="element-9423" data-mp="1o6z7i3o51ayc">
              <Icon className={`w-4 h-4 flex-shrink-0 ${TONE_ICON[alert.tone]}`} data-id="element-9424" data-mp="1agc8eaegtj1q" />
              <span className="flex-1 text-sm font-medium text-slate-800" data-id="element-9425" data-mp="15gzl5ojom9ym">
                {alert.message}
              </span>
              <ChevronRight className="w-4 h-4 text-slate-400 flex-shrink-0" data-id="element-9426" data-mp="10g38oml9lfhl" />
            </button>;
      }
      return <div key={alert.id} className={baseRow} role="listitem" data-id="element-9427" data-mp="rgy9rf5sjk4w">
            <Icon className={`w-4 h-4 flex-shrink-0 ${TONE_ICON[alert.tone]}`} data-id="element-9428" data-mp="rij87fv87n81" />
            <span className="flex-1 text-sm font-medium text-slate-800" data-id="element-9429" data-mp="2qtart1diztzv">
              {alert.message}
            </span>
          </div>;
    })}
      {hiddenCount > 0 && <div className="p-2 bg-slate-50 text-center" data-id="element-9430" data-mp="2tdz2izmfhh2l">
          <span className="text-xs font-bold text-slate-500" data-id="element-9431" data-mp="2ydbozj9e0m4n">
            + {hiddenCount} meer
          </span>
        </div>}
    </div>;
}